import { Controller } from "@hotwired/stimulus";

export default class SubmitFormController extends Controller {
  submit(e) {
    document.getElementById("tab_report_type").value = this.element.value;
    document.getElementById("submit_select_date_and_report_type").click();

    const tab_spinners = document.getElementsByClassName("tab-spinner");
    for (const tab_spinner of tab_spinners) {
      tab_spinner.classList.remove("hidden");
    }
  }
}
